import React from "react";
import QuickQuote from "../../../components/QuickQuote/QuickQuote";
// @ts-ignore
import "./HeroSection.css";

const trustPoints = [
  { icon: "fas fa-user-tie", text: "Professional chauffeurs" },
  { icon: "fas fa-car", text: "Meticulously maintained cars" },
  { icon: "fas fa-plane", text: "PHL, EWR & JFK transfers" },
  { icon: "fas fa-map-marked-alt", text: "NJ · PA · NY service area" },
];

export default function HeroSection(): JSX.Element {
  const bg = `url(${process.env.PUBLIC_URL}/images/home-banner.webp)`;

  return (
    <section className="hero-section" id="home">
      <div className="hero-bg" style={{ backgroundImage: bg }}></div>
      <div className="hero-overlay"></div>
      <div className="container hero-content text-center">
        <p className="hero-tagline">Luxury Travel</p>
        <h1 className="hero-title">Limo &amp; Black Car Service in Glassboro, NJ</h1>
        <p className="hero-services">
          Airport transfers, corporate travel, and special occasions across New
          Jersey, Pennsylvania, and New York. Spotless cars, professional
          chauffeurs, and a pickup plan confirmed with you before the ride.
        </p>

        <QuickQuote />

        <div className="hero-call">
          <span>Prefer to talk?</span>
          <a
            href="tel:9294526031"
            title="Call GS Limo Elite at (929) 452-6031"
          >
            <i className="fas fa-phone me-2" aria-hidden="true"></i>
            (929) 452-6031
          </a>
        </div>

        <ul className="hero-trust">
          {trustPoints.map((point) => (
            <li key={point.text}>
              <i className={point.icon} aria-hidden="true"></i>
              {point.text}
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
